export default "__VITE_ASSET__CLc4vVwr__"